<template>
  <div id="login">
    <div class="loginConbox">
      <div class="loginBox">
        <div class="loginCon">
          <el-card shadow="always" class="login-module" v-if="smdl">
            <div class="bg_left">
              <div class="flex_align">
                <img src="../../../static/images/x_logo.png" alt="" srcset="" />
                <span>OMS系统</span>
              </div>
            </div>
            <div class="login_right">
              <div slot="header" class="clearfix formTitlt">
                <span>欢迎登录</span>
              </div>
              <el-form :model="loginForm" status-icon class="demo-ruleForm">
                <el-form-item>
                  <input
                    class="ipt"
                    type="text"
                    placeholder="请输入登录账号"
                    v-model="loginForm.username"
                    :disabled="isLoading"
                    style="background-color: #ffffff !important"
                  />
                  <!-- <el-input
                    type="text"
                    v-model="loginForm.username"
                    placeholder="请输入登录账号"
                    :disabled="isLoading"
                    auto-complete="off"
                  ></el-input> -->
                  <!-- <i class="username_bg"></i> -->
                  <span class="svg-container">
                    <SvgIcon icon-class="user" />
                  </span>
                </el-form-item>
                <el-form-item class="mb-90">
                  <input
                    class="ipt"
                    placeholder="请输入登录密码"
                    v-model="loginForm.password"
                    :disabled="isLoading"
                    type="password"
                    style="background-color: #ffffff !important"
                  />
                  <!-- <el-input
                    type="password"
                    v-model="loginForm.password"
                    placeholder="请输入登录密码"
                    :disabled="isLoading"
                    auto-complete="off"
                  ></el-input> -->
                  <!-- <i class="passwod_bg"></i> -->
                  <span class="svg-container">
                    <SvgIcon icon-class="password" />
                  </span>
                </el-form-item>
                <br />
                <el-form-item>
                  <el-button
                    class="subBtn"
                    type="primary"
                    @click="submitForm"
                    @keyup.enter.native="submitForm('loginData')"
                    :loading="isLoading"
                    >{{ isLoading ? "登录中" : "登录" }}</el-button
                  >
                </el-form-item>
                <div class="tips-box">
                  <div class="flex tips cursor">
                    帮助<span>|</span>隐私<span>|</span>条款
                  </div>
                  <div class="flex tips">
                    Copyright © 2017 新诚智慧医药IT技术部出品
                  </div>
                </div>
              </el-form>
            </div>
          </el-card>
          <el-dialog
            title="获取码验证"
            :visible.sync="showCodeLogin"
            width="550px"
            center
          >
            <div class="flex">
              <el-input
                placeholder="请输入手机号码"
                prefix-icon="el-icon-phone-outline"
                v-model="PhoneNumber"
                class="w280"
              ></el-input>
              <el-button
                type="success"
                size="mini"
                @click="getCode"
                class="ml30 w120"
                >{{ codeTitle }}</el-button
              >
            </div>
            <div class="mt20">
              <el-input
                placeholder="请输入验证码"
                prefix-icon="el-icon-edit-outline"
                v-model="PhoneCode"
                class="w280"
              ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showCodeLogin = false" size="mini"
                >取 消</el-button
              >
              <el-button type="primary" @click="submitForm('code')" size="mini"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <div class="loginFoot">
      <ul style="list">
        <li>
          <span>浏览器：</span>
          <span>Win7以上(推荐)</span>
          <a
            href="https://pubstorage-bucket.oss-cn-shenzhen.aliyuncs.com/tools/win7/ChromeSetup_32.exe"
            target="_blank"
            rel="noopener noreferrer"
            >谷歌32位</a
          >
          <a
            href=" https://pubstorage-bucket.oss-cn-shenzhen.aliyuncs.com/tools/win7/ChromeSetup_64.exe"
            target="_blank"
            rel="noopener noreferrer"
            >谷歌64位</a
          >
          <span>|</span>
          <span>打印控件：</span>
          <a
            href="http://stg-file.cloud.xczhyf.cn/software/Zonerich_Printer.exe"
            target="_blank"
            rel="noopener noreferrer"
            >下载控件</a
          >
          <span>|</span>
          <span>高拍仪控件：</span>
          <a
            href="http://stg-file.cloud.xczhyf.cn/software/ltgpy_SDKV2.3.0.exe"
            target="_blank"
            rel="noopener noreferrer"
            >下载控件</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import JSEncrypt from "jsencrypt";
export default {
  data() {
    return {
      showCodeLogin: false,
      PhoneNumber: "",
      codeTitle: "获取验证码",
      PhoneCode: "",
      smdl: true,
      loginForm: {
        username: "",
        password: ""
      },
      isLoading: false
    };
  },
  methods: {
    getCode() {
      if (this.PhoneNumber == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return false;
      }
      if (this.PhoneNumber != undefined) {
        if (!/^1[3456789]\d{9}$/.test(this.PhoneNumber)) {
          this.MGridUtil.MessageShow("手机号码有误", "warning");
          return false;
        }
      }
      let phone = this.PhoneNumber;
      if (this.codeTitle == "获取验证码") {
        this.request(
          this.Appconstance.REQUEST_TYPE.GET,
          this.adminApi.upload.getPhonVerifyCode + phone,
          {}
        ).then(res => {
          if (res.status == 200) {
            this.MGridUtil.MessageShow(res.info, "success");
            let time = 60;
            let SetTime = setInterval(() => {
              time -= 1;
              this.codeTitle = time + "秒后请重新发送";
              if (time == 0) {
                this.codeTitle = "获取验证码";
                clearInterval(SetTime);
              }
            }, 1000);
          }
        });
      } else {
        this.MGridUtil.MessageShow("请勿重复发送验证码", "warning");
        return false;
      }
    },
    //登录成功
    redirectPage(res) {
      let option = {
        role: res.data.page,
        permissions: res.data.mapInfo.userName
      };
      // 权限设置
      this.$store.dispatch("setRole", option);
      // 把当前登录用户信息存入state
      this.$store.commit("saveUserInfo", res.data);
      // 将token进行存储
      this.$store.dispatch("setToken", res.data.mapInfo.token).then(() => {
        // 防止进入首页后点击空格继续访问登录接口
        document.onkeydown = undefined;
        if (this.loginForm.username == "dev") {
          this.$router.push("/functionalManage");
        } else {
          // 跳转到首页
          this.$router.push("/");
        }
      });
    },
    submitForm(val) {
      if (this.loginForm.username === "" || this.loginForm.password === "") {
        this.$message({
          showClose: true,
          message: "账号或密码不能为空",
          type: "error"
        });
        return false;
      } else {
        this.isLoading = true;
        let _this = this;
        let data = {};
        let publicKey =
          "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCE8+EiLAHM9Wd1Nww2thJSEcYJ7ekVx63yCRvkvhygIeHZ8CO/Ss8LLQ1trMNDs7/JfuR6mZWvR0gR49Z51gjpm0cetKSkIwAH4IkTVQ00xyot4EYGvuGWULKaRbqjTt/cpDAe6FhKiSWOKK6vLXpiZXQTaC8cDmM1OlgStX6HBQIDAQAB";
        let encryptor = new JSEncrypt();
        encryptor.setPublicKey(publicKey); // 设置公钥
        data.suAccount = encryptor.encrypt(_this.loginForm.username); // 对账号进行加密
        data.suPassword = encryptor.encrypt(_this.loginForm.password); // 对密码进行加密
        data.appCode = "MENDIAN";
        if (val == "code") {
          data.suTel = _this.PhoneNumber;
          if (_this.PhoneCode == "") {
            this.MGridUtil.MessageShow("请输入验证码", "warning");
            return false;
          }
          data.verifyCode = _this.PhoneCode;
        }
        this.$axios
          .post(
            process.env.API_ROOT + this.adminApi.homerenovation.dologin,
            data,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              }
            }
          )
          .then(res => {
            if (res.data.status === "200") {
              // let option = {
              //   role: "employee",
              //   permissions: "胡耀飞"
              // };
              // res.data.page = "developer";
              // res.data.mapInfo.menusFunction = menusFunction;
              let menusFunction = [
                // {
                //   fnId: 401,
                //   fnIsDisable: "否",
                //   fnName: "基础配置",
                //   isCollection: 0,
                //   fnCode: "basicConfiguration",
                //   fnParentId: 0,
                //   fnPath: "",
                //   childNodes: [
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 56,
                //       fnIsDisable: "否",
                //       fnName: "快递业务类型",
                //       fnParentId: 403,
                //       fnPath: "/expressBusinessType",
                //       fnCode: "expressBusinessType",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     },
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 57,
                //       fnIsDisable: "否",
                //       fnName: "CRM部门配置",
                //       fnParentId: 403,
                //       fnPath: "/crmDeptConfiguration",
                //       fnCode: "crmDeptConfiguration",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     }
                //   ]
                // },
                // {
                //   fnId: 403,
                //   fnIsDisable: "否",
                //   fnName: "CRM订单管理",
                //   isCollection: 0,
                //   fnPath: "",
                //   fnCode: "CRMORDER",
                //   fnParentId: 0,
                //   childNodes: [
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 1,
                //       fnIsDisable: "否",
                //       fnName: "产品管理",
                //       fnParentId: 403,
                //       fnCode: "productManagement",
                //       fnPath: "/productManagement",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     },
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 6,
                //       fnIsDisable: "否",
                //       fnName: "发货管理",
                //       fnParentId: 403,
                //       fnPath: "/shippingTemplate",
                //       fnCode: "shippingTemplate",
                //       fnSequence: 6,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     },
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 2,
                //       fnIsDisable: "否",
                //       fnName: "订单管理",
                //       fnParentId: 403,
                //       fnPath: "/orderManagement",
                //       fnCode: "orderManagement",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     },
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 3,
                //       fnIsDisable: "否",
                //       fnName: "波次管理",
                //       fnParentId: 403,
                //       fnPath: "/waveManagement",
                //       fnCode: "waveManagement",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     },
                //     {
                //       fnIcon: "el-icon-notebook-1",
                //       fnId: 4,
                //       fnIsDisable: "否",
                //       fnName: "退货管理",
                //       fnParentId: 403,
                //       fnCode: "returnManagement",
                //       fnPath: "/returnManagement",
                //       fnSequence: 2,
                //       fnShowMenu: "是",
                //       hasThisFn: false,
                //       isCollection: 0
                //     }
                //   ]
                // }
              ];
              this.redirectPage(res);
            } else if (res.data.status == "1001_0125") {
              this.showCodeLogin = true;
            } else {
              _this.$message({
                message: res.data.info,
                type: "error"
              });
            }
            this.isLoading = false;
          })
          .catch(e => {});
      }
    }
  },
  created() {
    var _self = this;
    document.onkeydown = function(e) {
      let key = null;
      if (window.event == undefined) {
        key = e.keyCode;
      } else {
        key = window.event.keyCode;
      }
      if (key == 13) {
        _self.submitForm("loginData");
      }
    };
  },
  watch: {
    showCodeLogin(val) {
      if (!val) {
        this.PhoneNumber = "";
        this.PhoneCode = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped="scoped">
#login {
  width: 100%;
  height: 100%;
  background: url(../../../static/images/base_map.png) no-repeat 0 0;
  background-size: 100% 100%;
  .loginConbox {
    // background: url(../../../static/images/bg_top.png) no-repeat 10% 5%;
    margin-bottom: 10%;
    height: 610px;
    .loginBox {
      height: 100%;
      .iconcolor {
        color: #409eff;
      }
      // padding-top: 74px 0 118px;
      .loginCon {
        width: 1200px;
        margin: auto;
        position: relative;
        height: 100%;
        padding-top: 85px;
        .el-card__header {
          border-bottom: 0px;
        }
        .title {
          font-size: 36px;
          font-weight: 600;
          color: #ffffff;
          width: 380px;
          float: left;
          margin-top: 0px;
          text-align: center;
          &:first-child {
            font-size: 34px;
            margin-top: 50px;
            margin-bottom: 30px;
          }
        }
        .login-module {
          width: 100%;
          height: 100%;
          margin-top: 60px;
          border: none;
          position: absolute;
          right: 0;
          .bg_left {
            width: 670px;
            background-image: url(../../../static/images/picture.png);
            background-size: cover;
            padding-top: 67px;
            div.flex_align {
              height: 66px;
              padding: 0 109px;
              align-items: center;
              img {
                width: 100px;
              }
              span {
                margin-left: 10px;
                font-size: 36px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #fefefe;
              }
            }
          }
          .login_right {
            width: 530px;
          }
          .formTitlt {
            font-size: 26px;
            font-weight: 400;
            padding-top: 60px;
            margin-bottom: 50px;
            span {
              text-align: center;
              // padding: 30px 10px;
              // color: rgba(101, 101, 101, 1);
              // font-weight: 600;
              // width: 143px;
              height: 35px;
              font-size: 36px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #666666;
              line-height: 20px;
            }
          }
        }
        .el-form-item__content {
          margin-left: 0px !important;
          .subBtn {
            width: 100%;
            border: none;
            display: block;
            padding: 10px;
            font-size: 16px;
            height: 56px;
            background: #61a7cf;
            border-radius: 28px;
            margin-bottom: 66px;
          }
        }
        .tips-box {
          padding-top: 30px;
          span {
            padding: 0 10px;
          }
          .cursor {
            cursor: pointer;
            margin-bottom: 5px;
          }
          .tips {
            font-weight: 400;
            justify-content: center;
            height: 21px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            color: #666666;
            line-height: 22px;
          }
        }
      }
      .el-input__inner,
      .el-card,
      .el-message {
        border-radius: 0px !important;
      }
      .el-form-item__content .ico {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 999;
        width: 40px;
        height: 39px;
        text-align: center;
        border-right: 1px solid #ccc;
      }
      .ewmbox {
        width: 100%;
        height: 240px;
        margin-top: -25px;
        .ewm {
          width: 140px;
          height: 140px;
          margin: 20px auto;

          p {
            font-size: 12px;
            padding-left: 40px;
            margin: 0;
          }
        }
        .ewmicon {
          width: 140px;
          margin: 20px auto 0;
          .iconfont {
            float: left;
          }
          p {
            font-size: 12px;
            padding-left: 40px;
            margin: 0;
          }
        }
      }
    }
  }
  .loginFoot {
    width: 100%;
    // position: absolute;
    // bottom: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    ul {
      list-style-type: none;
      display: flex;
      justify-content: center;
      li {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        color: #fff;
        a {
          margin-right: 10px;
        }
      }
    }
  }
}
.w280 {
  width: 280px;
}
.mt20 {
  margin-top: 20px;
}
.w120 {
  width: 120px;
  border-radius: 4px;
}
.login-module /deep/ .el-card__body {
  display: flex;
  height: 100%;
  padding: 0 !important;
}
.svg-container {
  position: absolute;
  left: 5px;
  font-size: 24px;
}
.demo-ruleForm input {
  border: 0;
}
.demo-ruleForm .ipt {
  width: 100%;
  position: relative;
  background: #fff !important;
  color: #333 !important;
  padding-left: 50px;
  border: 0;
  border-bottom: 1px solid rgba(69, 97, 217, 1);
  outline: none;
  line-height: 28px;
}
.demo-ruleForm input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
.demo-ruleForm /deep/ .el-form-item {
  padding: 0 50px;
}
.mb-90 {
  margin-bottom: 86px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue